import React, { ReactNode } from 'react';
import { Typography, styled } from '@mui/material';

const Field = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
  minWidth: 0,
}));

interface FormFieldProps {
  label: string;
  children: ReactNode;
}

// Rótulo acima do campo; o campo filho deve ser renderizado sem `label` próprio.
const FormField: React.FC<FormFieldProps> = ({ label, children }) => {
  return (
    <Field>
      <Typography variant="caption" color="textSecondary" fontWeight={500}>
        {label}
      </Typography>
      {children}
    </Field>
  );
};

export default FormField;
